import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TableColumn } from 'src/app/models/TableColumn';
import { TicketDto } from 'src/app/models/Tickets/TicketDto';
import { TicketService } from 'src/app/services/tickets.service';
import { ClickableCellComponent } from './clickable-cell/clickable-cell.component';
import { ResponseBase } from 'src/app/models/ResponseBase';
import { AlertService } from 'src/app/shared/services/alert.service';

import { FormsModule } from '@angular/forms';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
import { ModalAlertControlComponent } from '../../../shared/controls/modal-alert-control/modal-alert-control.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
declare var bootstrap: any;

@Component({
    selector: 'app-tickets-list',
    templateUrl: './tickets-list.component.html',
    styleUrl: './tickets-list.component.css',
    imports: [
        FormsModule,
        RouterModule,
        TableControlComponent,
        ModalAlertControlComponent,
        TooltipDirective
    ]
})
export class TicketsListComponent {

  selectedTicket: TicketDto | null = null;

  tickets: TicketDto[] = [];

  filteredTickets: TicketDto[] = [];

  viewArchivedTickets: boolean = false;

  columns: TableColumn[] = [
    { key: 'userName', header: 'User', width: 250 },
    {
      key: 'iccid', header: 'Iccid',
      renderComponent: ClickableCellComponent,

    },
    { key: 'error', header: 'Error', width: 250 },
    { key: 'description', header: 'Description', width: 250 },
    { key: 'comment', header: 'Comment', width: 250 },
    { key: 'statusId', header: 'Status' },
    { key: 'dateCreated', header: 'Date Created', width: 200 },
    { key: 'dateUpdated', header: 'Date Updated', width: 200 },
  ];

  actionButtons = [
    { label: 'view', tooltip: 'View Ticket', class: 'secondary', icon: 'bi bi-eye' },
    { label: 'edit', tooltip: 'Edit Ticket', class: 'primary', icon: 'bi bi-pencil' },
    { label: 'archive', tooltip: () => true ? 'Restore Ticket' : 'Archive Ticket', class: 'danger', icon: 'bi bi-archive' },

  ];

  /**
   *
   */
  constructor(private ticketService: TicketService, private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
  ) {

  }

  ngOnInit() {
    //this.permissionsService.validateAccessLevels(this.idModule);
    this.ticketService.getAllTickets().subscribe(
      (response: TicketDto[]) => {

        if (response != null) {
          this.tickets = [...response];

          this.filteredTickets = response.filter(ticket => ticket.isArchived === null || !ticket.isArchived);
        }
      });

  }

  onAction(event: { action: string; item: TicketDto }): void {

    switch (event.action) {
      case 'view':
        this.router.navigate(['/tickets/view/' + event.item.id], {
          relativeTo: this.route,
          //state: { simData: sim },
        });
        break;
      case 'edit':
        this.router.navigate(['/tickets/update/' + event.item.id], {
          relativeTo: this.route,
          //state: { simData: sim },
        });
        break;
      case 'archive':
        this.selectedTicket = event.item;
        bootstrap.Modal.getOrCreateInstance(document.getElementById('ticketArchiveConfirmationAlert')).show();
        break;
    }
  }

  onTicketArchiveConfirmed(): void {
    this.ticketService.archiveTicket(this.selectedTicket?.id).subscribe(
      (response: ResponseBase) => {
        bootstrap.Modal.getOrCreateInstance(document.getElementById('ticketArchiveConfirmationAlert')).hide();
        if (response) {
          if (response.hasValidationErrors) {
            this.alertService.error(response.validationErrorMessage);
          }
          else {
            this.alertService.success("Ticket archived successfully.");
            this.tickets.forEach(ticket => {
              if (ticket.id === this.selectedTicket?.id) {
                ticket.isArchived = true;
              }
            });
           
            if (this.viewArchivedTickets) {
              this.filteredTickets = this.tickets.filter(ticket => ticket.isArchived);
              this.actionButtons = [
                { label: 'view', tooltip: 'View Ticket', class: 'secondary', icon: 'bi bi-eye' },
              ];

            } else {
              this.actionButtons = [
                { label: 'view', tooltip: 'View Ticket', class: 'secondary', icon: 'bi bi-eye' },
                { label: 'edit', tooltip: 'Edit Ticket', class: 'primary', icon: 'bi bi-pencil' },
                { label: 'archive', tooltip: () => true ? 'Restore Ticket' : 'Archive Ticket', class: 'danger', icon: 'bi bi-archive' },

              ];
              this.filteredTickets = this.tickets.filter(ticket => ticket.isArchived === null || !ticket.isArchived);
            }

          }
          // Handle successful archive, e.g., refresh the list or show a success message

        }
      },
      (error) => {
        bootstrap.Modal.getOrCreateInstance(document.getElementById('ticketArchiveConfirmationAlert')).hide();
        // Handle error, e.g., show an error message
        this.alertService.error("Failed to archive ticket.");
        //console.error('Error archiving ticket:', error);
      }
    );
  }

  onCheckboxChange(event: Event): void {

    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.filteredTickets = this.tickets.filter(ticket => ticket.isArchived);
      this.actionButtons = [
        { label: 'view', tooltip: 'View Ticket', class: 'secondary', icon: 'bi bi-eye' },
      ];

    } else {
      this.actionButtons = [
        { label: 'view', tooltip: 'View Ticket', class: 'secondary', icon: 'bi bi-eye' },
        { label: 'edit', tooltip: 'Edit Ticket', class: 'primary', icon: 'bi bi-pencil' },
        { label: 'archive', tooltip: () => true ? 'Restore Ticket' : 'Archive Ticket', class: 'danger', icon: 'bi bi-archive' },

      ];
      this.filteredTickets = this.tickets.filter(ticket => ticket.isArchived === null || !ticket.isArchived);
    }
  }

}
